import Pagination from "component/react-bootstrap/Pagination";
import styles from "./paPagination.module.scss";

const PAPagination = (props) => {
  const { className = "", containerClassName } = props;
  return (
    <div className={`${styles.pagination_container} ${containerClassName}`}>
      <Pagination className={className} {...props} />
    </div>
  );
};

export default PAPagination;
